import { service } from "@server/client";
import type {
  UpdateCartMetadataMutation,
  UpdateCartMetadataMutationVariables,
} from "@server/gql/graphql";
import { updateCartMetadataMutation } from "@server/queries/cart";

export const updateCartMetadata = async (
  variables: UpdateCartMetadataMutationVariables,
) => {
  try {
    const response = await service<
      UpdateCartMetadataMutation,
      UpdateCartMetadataMutationVariables
    >({
      query: updateCartMetadataMutation,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in updateCartMetadata", error);
    throw error;
  }
};
